import { Box, Flex, Typography, useDevice } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { useIdoInfo } from '../../common/hooks/useIdoInfo';
import { TimelineRound } from './TimelineRound/TimelineRound';

export const Timeline: FC = () => {
  const idoInfo = useIdoInfo();

  const { s, valBySize } = useDevice();

  return (
    <Box padding={4} borderRadius="l">
      <Flex col width="100%">
        <Flex.Item marginBottom={6}>
          <Typography.Title level={4}>Timeline</Typography.Title>
        </Flex.Item>
        <Flex.Item display="flex" col={s} width="100%">
          {idoInfo.rounds.map((round, index) => (
            <Flex.Item
              key={round.code}
              flex={1}
              marginRight={valBySize(
                0,
                index === idoInfo.rounds.length - 1 ? 0 : 4,
              )}
              marginBottom={valBySize(
                index === idoInfo.rounds.length - 1 ? 0 : 4,
                0,
              )}
            >
              <TimelineRound
                showSubmittedProgress={
                  idoInfo.currentRound?.activeSubround === 'contribution'
                }
                currentRound={
                  round.code === idoInfo.currentRound?.code
                    ? idoInfo.currentRound
                    : undefined
                }
                round={round}
                now={idoInfo.now}
              />
            </Flex.Item>
          ))}
        </Flex.Item>
      </Flex>
    </Box>
  );
};
